export enum CodeType {
    FRONTEND = 'front-end',
    BACKEND = 'back-end',
    MOBILE = 'mobile'
  }